import { useNavigate } from "react-router-dom";

function BackButton({ className = "", dark = false }) {
  const navigate = useNavigate();

  // Agar 'dark={true}' pass karoge to icon Black hoga, warna White rahega.
  const iconColor = dark ? "text-dark" : "text-white";
  const hoverBg = dark ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.2)";

  return (
    <button
      onClick={() => navigate(-1)}
      className={`btn border-0 p-0 d-flex align-items-center justify-content-center ${className}`}
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%", // Gol button
        background: "transparent", // Default transparent
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        backdropFilter: "blur(4px)", // ✨ Glass Effect
      }}
      // Hover Effect: Mouse upar jane par thoda background aayega
      onMouseEnter={(e) => (e.currentTarget.style.background = hoverBg)}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      {/* Chevron Icon thoda modern lagta hai arrow se */}
      <i className={`bi bi-chevron-left fs-5 ${iconColor}`}></i> 
    </button>
  );
}

export default BackButton;